import { memo } from 'react';
import { Badge } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';

import { USER_TYPE_META } from '../../constants/copy';

/** User type badge (Member, Admin, Owner) from the central vocabulary. */
const UserTypeBadge = ({ userType }) => {
  const { t } = useTranslation('people-access');
  const meta = USER_TYPE_META[userType];

  if (!meta) return null;

  return <Badge variant={meta.variant}>{t(meta.labelKey)}</Badge>;
};

export default memo(UserTypeBadge);
